import { useRecoilState } from 'recoil'
import message from '@/libs/message'
import deleteSystemApprovalAtom from '@/recoil/deleteSystemApprovalModal'
import { useDeleteHealthClaimApproveLevel } from '@/services/healthClaim/useDeleteHealthClaimApproveLevel'

export default function DeleteApprovalModalHook() {
  const [deleteClaimSystemApprovalModal, setDeleteClaimSystemApprovalModal] =
    useRecoilState(deleteSystemApprovalAtom)

  const { mutateAsync: deleteClaimApproveLevel, isPending: isPendingApproval } =
    useDeleteHealthClaimApproveLevel()

  const handleSetDeleteApprovalModal = () => {
    if (deleteClaimSystemApprovalModal.backofficeUserId)
      deleteClaimApproveLevel(deleteClaimSystemApprovalModal.backofficeUserId)
        .finally(() => {
          setDeleteClaimSystemApprovalModal({
            backofficeUserId: undefined,
            open: false,
            fullname: undefined,
          })
          if (deleteClaimSystemApprovalModal.onSuccess) deleteClaimSystemApprovalModal.onSuccess()
        })
        .catch(() => {
          message.error({
            content: `เกิดข้อผิดพลาด`,
            duration: 10,
          })
        })
  }

  const onCancelModal = () => {
    setDeleteClaimSystemApprovalModal({
      backofficeUserId: undefined,
      open: false,
      fullname: undefined,
    })
  }

  return {
    deleteClaimSystemApprovalModal,
    handleSetDeleteApprovalModal,
    onCancelModal,
    fullname: deleteClaimSystemApprovalModal.fullname,
    isPendingApproval,
  }
}
